import React from 'react';

import { Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender } from '@philips-emr/tws-core/lib/client';
import { RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames, HistoricoParticipacoesAliases } from '../../codegen';

enum Status {
  A = 'A',
  C = 'C',
  N = 'N',
  P = 'P',
  R = 'R',
  T = 'T',
}

@Controller({ fragment: FragmentNames.HISTORICO_PARTICIPACOES })
export default class HistoricoParticipacoesController {

  @OnDynamicContentRender(HistoricoParticipacoesAliases.HPMS_DYNAMIC_CONTENT_FIELD_STATUS)
  onDynamicContentRender({ data, render }: RenderEvent): void {
    const { ieStatus } = data as { ieStatus: Status };

    const props = {
      [Status.A]: { icon: StampIcon.CHECK, color: Color.SAFETY_GREEN },
      [Status.C]: { icon: StampIcon.CANCELED_OUTLINE, color: Color.SAFETY_ORANGE },
      [Status.N]: { icon: StampIcon.WARNING, color: Color.SAFETY_YELLOW },
      [Status.P]: { icon: StampIcon.CLOCK, color: Color.SAFETY_NEUTRAL },
      [Status.R]: { icon: StampIcon.CANCELED, color: Color.SAFETY_RED },
      [Status.T]: { icon: StampIcon.CHECK, color: Color.SAFETY_BLUE },
    };

    render(() => <Stamp {...props[ieStatus]} label={`@beneficiary.status-captacao/${ieStatus}`.toLowerCase()} />);
  }
}
